const LANGUAGE_MAP = {
  de: "Deutsch",
  en: "English",
  fr: "Français",
  es: "Español",
  it: "Italiano",
  "zh-CN": "中文",
  ru: "Русский"
};

export { LANGUAGE_MAP };
